import React, { useEffect } from 'react';
import './Policies.css'; // Import CSS for styling

const TermsAndConditions = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    return (
        <div className="terms-wrapper">
            <div className="terms-container">
                <h1>Terms and Conditions for Purchase</h1>
                <p>Last Updated: April 29, 2025</p>

                <section>
                    <h2>1. Scope of Work</h2>
                    <p>
                        The Supplier Partner is presumed to have understood the scope of supply as outlined in the Purchase Order. Any work not explicitly mentioned but required as per industry standards shall be deemed included in the scope of supply.
                    </p>
                </section>

                <section>
                    <h2>2. Acceptance</h2>
                    <p>
                        A formal order amendment will be issued for any agreed changes. The order is deemed accepted if the Supplier Partner proceeds with execution or does not respond within 7 days of receipt.
                    </p>
                </section>

                <section>
                    <h2>3. Price</h2>
                    <p>
                        Prices are inclusive of all taxes and duties unless specified otherwise and are FOR our factory. Prices are firm, with no variations allowed during the contract unless agreed in writing. Shipping terms follow the latest INCO terms.
                    </p>
                </section>

                <section>
                    <h2>4. Packing & Forwarding</h2>
                    <p>
                        Unless specified, prices include packing and forwarding charges. The Supplier Partner must ensure suitable transport and, where applicable, export-worthy or sea-worthy packing to prevent damage, breakage, or pilferage.
                    </p>
                </section>

                <section>
                    <h2>5. Invoicing</h2>
                    <p>
                        Invoices must reference the Purchase Order and include all tax registration numbers as per the order instructions.
                    </p>
                </section>

                <section>
                    <h2>6. Inspection</h2>
                    <p>
                        Unless otherwise specified, inspections will occur upon receipt of materials by the Buyer.
                    </p>
                </section>

                <section>
                    <h2>7. Rejection</h2>
                    <p>
                        If supplies are defective or non-conforming, a discrepancy notice will be sent. Replacements must be provided free of charge, and rejected items returned on a "freight to collect" basis or as agreed.
                    </p>
                </section>

                <section>
                    <h2>8. Counterfeit Items</h2>
                    <p>
                        Counterfeit items will be scrapped or destroyed by the Supplier Partner, with written confirmation to Aero Fasteners. Non-compliance may result in legal action by Aero Fasteners or relevant authorities.
                    </p>
                </section>

                <section>
                    <h2>9. Non-Conforming Product Notification</h2>
                    <p>
                        Any non-conformity detected after dispatch must be notified to Aero Fasteners within 48 hours or as specified.
                    </p>
                </section>

                <section>
                    <h2>10. Warranty</h2>
                    <p>
                        Unless specified otherwise, all materials carry a 1-year warranty against manufacturing defects and for satisfactory performance from the date of receipt. Supplies must include test certificates, certificates of conformance, or warranty certificates. The Supplier Partner bears all repair, freight, duties, and insurance costs during this period.
                    </p>
                </section>

                <section>
                    <h2>11. Payment</h2>
                    <p>
                        Payments will be made within the agreed timeframe from the date of receipt and acceptance of materials, unless specified otherwise. Overseas payments will be via DD, TT, or Letter of Credit as agreed.
                    </p>
                </section>

                <section>
                    <h2>12. Documentation</h2>
                    <p>
                        Documentation must include item descriptions, quantities, Purchase Order references, and Supplier Partner registration details (e.g., TIN). Losses due to improper documentation, including delays or detention by authorities, are the Supplier Partner’s responsibility.
                    </p>
                </section>

                <section>
                    <h2>13. Delivery</h2>
                    <p>
                        Delivery is critical, and the Supplier Partner must adhere to the schedule in the order, as amended by mutual agreement. The Buyer may cancel the contract and proceed with risk purchase at the Supplier Partner’s cost if delivery is not met.
                    </p>
                </section>

                <section>
                    <h2>14. Liquidated Damages (LD)</h2>
                    <p>
                        Liquidated Damages, as specified or agreed, are payable by the Supplier Partner, typically at 0.5% per week (or part thereof), up to a maximum of 10% of the order value (excluding taxes). This is adjusted against final payment.
                    </p>
                </section>

                <section>
                    <h2>15. Risk Purchase</h2>
                    <p>
                        The Buyer may undertake risk purchases without invoking Liquidated Damages, in part or in full.
                    </p>
                </section>

                <section>
                    <h2>16. Termination</h2>
                    <p>
                        The Buyer may terminate the order if delivery schedules or specifications are not met, without invoking Liquidated Damages or Risk Purchase clauses, in part or in full.
                    </p>
                </section>

                <section>
                    <h2>17. Confidentiality</h2>
                    <p>
                        The Supplier Partner must keep all transactions confidential and not disclose information to third parties without written consent from the Buyer.
                    </p>
                </section>

                <section>
                    <h2>18. Sub-Contracting</h2>
                    <p>
                        The Supplier Partner may not subcontract or assign the order without written consent from the Buyer. The Supplier Partner must inform the Buyer of any import/export license requirements and comply with applicable laws.
                    </p>
                </section>

                <section>
                    <h2>19. Force Majeure</h2>
                    <p>
                        This contract is subject to a standard Force Majeure clause.
                    </p>
                </section>

                <section>
                    <h2>20. Jurisdiction</h2>
                    <p>
                        This contract is governed by the jurisdiction of New Delhi, India.
                    </p>
                </section>

                <section>
                    <h2>21. Regulatory Authority</h2>
                    <p>
                        The Supplier Partner must comply with applicable regulatory authority requirements.
                    </p>
                </section>

                <section>
                    <h2>22. Process Change</h2>
                    <p>
                        The Supplier Partner must notify Aero Fasteners of any changes in product, process, suppliers, or manufacturing facility location and obtain approval before proceeding.
                    </p>
                </section>

                <section>
                    <h2>23. Right to Access</h2>
                    <p>
                        The Supplier Partner must maintain records to evidence conformity and provide access to Aero Fasteners, its customers, and regulatory authorities to applicable facilities and records.
                    </p>
                </section>

                <section>
                    <h2>24. Record Retention</h2>
                    <p>
                        The Supplier Partner must retain relevant records for 7 years or as specified in the contract, whichever is longer.
                    </p>
                </section>

                <section>
                    <h2>25. Ethics</h2>
                    <p>
                        The Supplier Partner must ensure personnel are aware of:
                        <ul>
                            <li>Their contribution to product or service conformity.</li>
                            <li>Their contribution to product safety.</li>
                            <li>The importance of ethical behavior.</li>
                        </ul>
                    </p>
                </section>
            </div>
        </div>
    );
};

export default TermsAndConditions;